function readHeader(headers, name) {
  if (!headers) return ''
  const lower = name.toLowerCase()
  return headers[name] || headers[lower] || ''
}

function positiveInt(value) {
  const number = Number(value)
  if (!isFinite(number) || number <= 0) return 0
  return Math.ceil(number)
}

function retryAfterHeaderSeconds(value) {
  if (!value) return 0

  const numeric = positiveInt(value)
  if (numeric) return numeric

  const dateValue = new Date(value).getTime()
  if (isNaN(dateValue)) return 0

  return positiveInt((dateValue - Date.now()) / 1000)
}

export function parseConfirmationResendResult(source) {
  const response = source && source.response ? source.response : source
  const data = response && response.data ? response.data : {}
  const headers = response && response.headers ? response.headers : {}
  const errorBody = data && data.error && typeof data.error === 'object' ? data.error : {}
  const errorMessage = data && typeof data.error === 'string' ? data.error : ''
  const headerRetryAfter = retryAfterHeaderSeconds(readHeader(headers, 'Retry-After'))
  const retryAfterSeconds = positiveInt(data.retryAfterSeconds || data.retry_after_seconds || errorBody.retryAfterSeconds || headerRetryAfter)
  const retryAfterMinutes = positiveInt(data.retryAfterMinutes || data.retry_after_minutes || errorBody.retryAfterMinutes || (retryAfterSeconds ? Math.ceil(retryAfterSeconds / 60) : 0))
  const cooldownMinutes = positiveInt(data.cooldownMinutes || data.cooldown_minutes || errorBody.cooldownMinutes)

  return {
    status: Number(data.status || (response && response.status) || 0),
    code: data.code || data.errorCode || errorBody.code || '',
    message: data.message || errorBody.message || errorMessage || '',
    emailSent: data.emailSent === true || data.email_sent === true,
    throttled: data.throttled === true || errorBody.throttled === true,
    retryAfterSeconds: retryAfterSeconds,
    retryAfterMinutes: retryAfterMinutes,
    cooldownMinutes: cooldownMinutes,
    reason: data.reason || errorBody.reason || '',
  }
}

export function confirmationResendNotice(outcome) {
  const code = outcome && outcome.code ? outcome.code : ''
  const status = outcome && outcome.status ? Number(outcome.status) : 0

  if (status === 200 && code === 'CONFIRMATION_EMAIL_SENT') {
    const cooldownSeconds = outcome.retryAfterSeconds || (outcome.cooldownMinutes ? outcome.cooldownMinutes * 60 : 60)
    return {
      type: 'success',
      title: 'Confirmation email sent.',
      text: 'Open the newest link in your inbox.',
      action: 'confirmation-resend',
      cooldownSeconds: cooldownSeconds,
      emailSent: true,
    }
  }

  if (status === 429 || code === 'EMAIL_RATE_LIMITED') {
    const retryAfterSeconds = outcome.retryAfterSeconds || (outcome.retryAfterMinutes ? outcome.retryAfterMinutes * 60 : 0)
    return {
      type: 'warning',
      title: 'Please wait before resending.',
      text: resendWaitText(outcome),
      action: 'confirmation-resend',
      cooldownSeconds: retryAfterSeconds,
      emailSent: false,
    }
  }

  if (status === 502 || code === 'CONFIRMATION_EMAIL_SEND_FAILED') {
    return {
      type: 'error',
      title: 'Email send failed.',
      text: 'We could not send the email right now. Please try again later.',
      action: 'confirmation-resend',
      cooldownSeconds: 0,
      emailSent: false,
    }
  }

  if (status === 200) {
    return {
      type: 'info',
      title: 'Request received.',
      text: 'If this account still needs confirmation, we will send a new link when allowed.',
      action: '',
      cooldownSeconds: 0,
      emailSent: false,
    }
  }

  return {
    type: 'error',
    title: 'Resend failed.',
    text: outcome && outcome.message ? outcome.message : 'We could not send the email right now. Please try again later.',
    action: 'confirmation-resend',
    cooldownSeconds: 0,
    emailSent: false,
  }
}

export function resendWaitText(outcome) {
  const seconds = outcome && outcome.retryAfterSeconds ? outcome.retryAfterSeconds : 0
  const minutes = outcome && outcome.retryAfterMinutes ? outcome.retryAfterMinutes : Math.ceil(seconds / 60)
  const displayMinutes = Math.max(1, minutes || 1)
  return 'Please wait ' + displayMinutes + ' ' + (displayMinutes === 1 ? 'minute' : 'minutes') + ' before requesting another email.'
}

export function cooldownButtonLabel(seconds) {
  const safeSeconds = positiveInt(seconds)
  if (!safeSeconds) return ''
  const minutes = Math.floor(safeSeconds / 60)
  const remainder = safeSeconds % 60
  if (minutes <= 0) return safeSeconds + 's'
  return minutes + ':' + String(remainder).padStart(2, '0')
}
